import type { Tagged } from "@-/com.npmjs.type-fest";
import { hasLength } from "@-/com.npmjs.ts-array-length";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";

export type MorphemeGlyphTilePinyinDotsGate = Tagged<
  { additionalPinyinList: readonly string[] },
  "MorphemeGlyphTilePinyinDotsGate"
>;

/**
 * Whether a tile shows its pinyin-dots row. `null` is the designed hidden state: no additional
 * readings and no reserved row. A `reserved` row renders even when empty, so glyph layout matches
 * tiles that have dots.
 */
export function getMorphemeGlyphTilePinyinDotsGate({
  additionalPinyinList,
  reserved,
}: {
  additionalPinyinList: readonly string[];
  reserved: boolean;
}): MorphemeGlyphTilePinyinDotsGate | null {
  if (!reserved && hasLength(additionalPinyinList, 0)) {
    return null;
  }
  return createGate<MorphemeGlyphTilePinyinDotsGate>({ additionalPinyinList });
}
